/*
Sohel  12/19/2022 3075154998 Added Data Manager Basic Info Screen and validation.
Sohel  12/19/2022 3075154998 label Changes.
Sohel 12/23/2022 3075154998 Integrated Basic Info API.
Lalitha 12/26/2022 3075154998 Integrated get API on DM code.
Sohel 01/04/2023 3075154998 disabled Fields.
dilip 01/04/2023 3075154998 disabled Fields.
Sohel 01/09/2023 3075154998 show Disable stepper value
Sohel 01/09/2023 3075154998 fixed Type issue.
Sohel 01/09/2023 3075154998 fixed page break issue.
dilip 01/10/2023 3075154998 Added unsaved popup.
Sohel 01/12/2023 3075154998 fixed page break issue.
dilip 01/12/2023 3075154998 Fixed message and status reset issue.
Sohel 01/18/2023 3075154998 Added Multi Record Format validation.
 dilip 01/20/2023 3075154998 Added Last Step functionality
Sohel 01/20/2023 3075154998 changed Dropdown Values
Ashraf 01/27/2023 3075154998 added new fields
Ashraf 01/31/2023 3075154998 fixed useEffect issue
Ashraf 01/31/2023 3075154998 fixed active step issue
Ravi 01/31/2023 3075154998 fixed unsaved popup issue
Sohel 01/02/2023 3075154998 fixed code uppercase issue
Sohel 01/02/2023 3075154998 fixed validation issue
Ashraf 02/03/2023 3075154998 fixed draft issue
sai krisha 02/13/2023 3075154998 added client code multislected checkbox filed and
Guru Prasad 02/13/2023 3075154998 fixed scroll issues in autocomplete
suresh peddavoora 02/22/2023 3075154998 New UI changes implemented
suresh peddavoora 02/27/2023 3075154998 New UI changes
Rohini 03/01/2023 3075154998 worked on the code enhancements.
sohel 03/06/2023 3075154998 Added validation message for existing value
Raghu 03/20/2023 3075154998 fixed input field in responsive
Prakash 03/21/2023 3075154998 Fixed alignments issue.
Akhila 04/19/2023 3075154998 client code dropDown Data fix
 Ravi 04/20/2023 3075154998 implement dynamic field name
 Ravi 04/24/2023 3075154998 Added popup in dynamic field name
 Prakash 24/04/2023 3075154998 fixed alignment issue for input filed
Sohel 04/26/2023 2692790263 Fixed Created FOr Validation Issue
 Ravi 04/27/2023 3075154998 show  dynamic field name conditionally
 Akhila 05/16/2023 3075154998 comment out disable for created for
 Ravi 05/23/2023 3075154998 Added Export Format file Field
Akhila 06/12/2023 3075154998 added role access
Sohel 06/19/2023 3075154998 Enable Save Button
Akhila 06/23/2023 3075154998 report folder path added
Suresh Peddavoora 06/23/2023 3075154998 Fixed report folder path alignments
Ravi 06/23/2023 3075154998 fixed submit issue
Ravi 06/15/2023 3075154998 removed by default initial value folder path and output file name
Akhila 30/06/2023 3075154998 condtionaly label name change for folder path and file name
*/
import React, {useContext, useEffect, useRef} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {
  TextField,
  FormHelperText,
  Button,
} from '@material-ui/core';
import {useSelector, useDispatch} from 'react-redux';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {
  postBasicInfo,
  fetchBasicInfoData,
  resetMsgAndStatus,
  getExportFormatType,
} from '../../../redux/reducers/EDI/index';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';

const DMBasicInfo = ({
  activeStep,
  handleNext,
  handleDirty,
  editExisting,
  setActiveStep,
  handleBack,
  setValue,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {
    isBasicInfoLoading,
    basicInfoErrorMsg,
    basicInfoSuccessMsg,
    addBasicInfoStatus,
    dmCode,
    basicInfoData,
  } = useSelector(({ediExport}) => ediExport);
  const saveRef = useRef();
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);


  const initialVal = {
    senderId: basicInfoData?.senderId ? basicInfoData?.senderId : '',
    receiverId: basicInfoData?.receiverId ? basicInfoData?.receiverId : '',
    customerReference: basicInfoData?.custReference ? basicInfoData?.custReference : '',
    originCompany: basicInfoData?.origCompany ? basicInfoData?.origCompany : '',
    customerLastName: basicInfoData?.custLastName ? basicInfoData?.custLastName : '',
    customerFirstName: basicInfoData?.custFirstName ? basicInfoData?.custFirstName : '',
    customerIdentifier: basicInfoData?.custIdentifier ? basicInfoData?.custIdentifier : '',
    customerAddress: basicInfoData?.custAddress ? basicInfoData?.custAddress : '',
    customerCity: basicInfoData?.custCity ? basicInfoData?.custCity : '',
    customerState: basicInfoData?.custState ? basicInfoData?.custState : '',
    customerZip: basicInfoData?.custZip ? basicInfoData?.custZip : '',
    customerBirthDate: basicInfoData?.custBirthDate ? basicInfoData?.custBirthDate : null,
  };

  const validationSchema = Yup.object().shape({});
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const payload = {
      edi270ExportId: basicInfoData?.edi270ExportId ? basicInfoData?.edi270ExportId : 0,
      exportCode: basicInfoData?.exportCode ? basicInfoData?.exportCode : '',
      exportDescription: basicInfoData?.exportDescription ? basicInfoData?.exportDescription : '',
      interchangeControlNumber: basicInfoData?.interchangeControlNumber ?
        basicInfoData?.interchangeControlNumber :
        '',
      hospitalName: basicInfoData?.hospitalName ? basicInfoData?.hospitalName : '',
      providerName: basicInfoData?.providerName ? basicInfoData?.providerName : '',
      hospitalCity: basicInfoData?.hospitalCity ? basicInfoData?.hospitalCity : '',
      hospitalState: basicInfoData?.hospitalState ? basicInfoData?.hospitalState : '',
      hospitalZip: basicInfoData?.hospitalZip ? basicInfoData?.hospitalZip : '',
      infoReceiverId: basicInfoData?.infoReceiverId ? basicInfoData?.infoReceiverId : '',
      auditDatePrompt: basicInfoData?.auditPrompt ? basicInfoData?.auditPrompt : '',
      clientIdPrompt: basicInfoData?.clientPrompt ? basicInfoData?.clientPrompt : '',
      senderId: values?.senderId ? values?.senderId : '',
      receiverId: values?.receiverId ? values?.receiverId : '',
      custReference: values?.customerReference ? values?.customerReference : '',
      origCompany: values?.originCompany ? values?.originCompany : '',
      custLastName: values?.customerLastName ? values?.customerLastName : '',
      custFirstName: values?.customerFirstName ? values?.customerFirstName : '',
      custIdentifier: values?.customerIdentifier ? values?.customerIdentifier : '',
      custAddress: values?.customerAddress ? values?.customerAddress : '',
      custCity: values?.customerCity ? values?.customerCity : '',
      custState: values?.customerState ? values?.customerState : '',
      custZip: values?.customerZip ? values?.customerZip : '',
      custBirthDate: values?.customerBirthDate ? values?.customerBirthDate : null,
    };
    dispatch(postBasicInfo(payload));
  };

  useEffect(() => {
    dispatch(getExportFormatType());
  }, []);

  useEffect(() => dispatch(resetMsgAndStatus()), []);

  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        if (addBasicInfoStatus === 200 && basicInfoSuccessMsg && !saveRef.current) {
          handleNext && handleNext();
        }
        dispatch(resetMsgAndStatus());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);

  useEffect(() => {
    if (dmCode) {
      dispatch(fetchBasicInfoData({code: dmCode}));
    }
  }, [dmCode]);

  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnBlur
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            // senderId
            // receiverId
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row global-field-textfields new-standard-textfields mt-2">
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Sender Id`}
                    label={`Sender Id`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="senderId"
                    value={values?.senderId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.senderId}
                    error={Boolean(touched.senderId && errors.senderId)}
                  />
                  <FormHelperText>
                    {touched.senderId && errors?.senderId && errors.senderId}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Receiver Id`}
                    label={`Receiver Id`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="receiverId"
                    value={values?.receiverId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.receiverId}
                    error={Boolean(touched.receiverId && errors.receiverId)}
                  />
                  <FormHelperText>
                    {touched.receiverId && errors?.receiverId && errors.receiverId}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Customer Reference`}
                    label={`Customer Reference`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="customerReference"
                    value={values?.customerReference}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.customerReference}
                    error={Boolean(touched.customerReference && errors.customerReference)}
                  />
                  <FormHelperText>
                    {touched.customerReference &&
                      errors?.customerReference &&
                      errors.customerReference}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Origin Company`}
                    label={`Origin Company`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="originCompany"
                    value={values?.originCompany}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.originCompany}
                    error={Boolean(touched.originCompany && errors.originCompany)}
                  />
                  <FormHelperText>
                    {touched.originCompany && errors?.originCompany && errors.originCompany}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Customer First Name`}
                    label={`Customer First Name`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="customerFirstName"
                    value={values?.customerFirstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.customerFirstName}
                    error={Boolean(touched.customerFirstName && errors.customerFirstName)}
                  />
                  <FormHelperText>
                    {touched.customerFirstName &&
                      errors?.customerFirstName &&
                      errors.customerFirstName}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Customer Last Name`}
                    label={`Customer Last Name`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="customerLastName"
                    value={values?.customerLastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.customerLastName}
                    error={Boolean(touched.customerLastName && errors.customerLastName)}
                  />
                  <FormHelperText>
                    {touched.customerLastName &&
                      errors?.customerLastName &&
                      errors.customerLastName}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Customer Identifier`}
                    label={`Customer Identifier`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="customerIdentifier"
                    value={values?.customerIdentifier}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.customerIdentifier}
                    error={Boolean(touched.customerIdentifier && errors.customerIdentifier)}
                  />
                  <FormHelperText>
                    {touched.customerIdentifier &&
                      errors?.customerIdentifier &&
                      errors.customerIdentifier}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Customer Address`}
                    label={`Customer Address`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="customerAddress"
                    value={values?.customerAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.customerAddress}
                    error={Boolean(touched.customerAddress && errors.customerAddress)}
                  />
                  <FormHelperText>
                    {touched.customerAddress && errors?.customerAddress && errors.customerAddress}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Customer City`}
                    label={`Customer City`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="customerCity"
                    value={values?.customerCity}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.customerCity}
                    error={Boolean(touched.customerCity && errors.customerCity)}
                  />
                  <FormHelperText>
                    {touched.customerCity && errors?.customerCity && errors.customerCity}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Customer State`}
                    label={`Customer State`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="customerState"
                    value={values?.customerState}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.customerState}
                    error={Boolean(touched.customerState && errors.customerState)}
                  />
                  <FormHelperText>
                    {touched.customerState && errors?.customerState && errors.customerState}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Customer Zip`}
                    label={`Customer Zip`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="customerZip"
                    value={values?.customerZip}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.customerZip}
                    error={Boolean(touched.customerZip && errors.customerZip)}
                  />
                  <FormHelperText>
                    {touched.customerZip && errors?.customerZip && errors.customerZip}
                  </FormHelperText>
                </div>
                {/* <div className={`col-sm-6 col-md-4 col-xl-3 form-group`}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        name="customerBirthDate"
                        autoOk
                        className={`${classes.labelName}`}
                        margin="dense"
                        helperText={""}
                        inputVariant="outlined"
                        format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        fullWidth
                        defaultValue={null}
                        //   InputLabelProps={{
                        //     shrink: true,
                        //   }}
                        label="Customer Birth Date"
                        value={values?.customerBirthDate}
                        onChange={(val) => {
                          setFieldValue("customerBirthDate", val);
                        }}
                        onBlur={handleBlur}
                        touched={touched?.customerBirthDate}
                        error={Boolean(touched?.customerBirthDate && errors?.customerBirthDate)}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <FormHelperText>
                    {touched?.customerBirthDate && errors?.customerBirthDate}
                  </FormHelperText>
                </div> */}
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Customer Birth Date`}
                    label={`Customer Birth Date`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="customerBirthDate"
                    value={values?.customerBirthDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.customerBirthDate}
                    error={Boolean(touched.customerBirthDate && errors.customerBirthDate)}
                  />
                  <FormHelperText>
                    {touched.customerBirthDate &&
                      errors?.customerBirthDate &&
                      errors.customerBirthDate}
                  </FormHelperText>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center new-standard-textfields disabled-button">
                <Button
                  variant="outlined"
                  disabled={activeStep === 0}
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    handleBack();
                  }}
                >
                  Back
                </Button>
                {/* {basicInfoData?.isDraft === "N" && ( */}
                <Button
                  variant="outlined"
                  type="button"
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                    handleSubmit(values);
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    saveRef.current = false;
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {isBasicInfoLoading && <PageLoader />}
      {basicInfoErrorMsg && <ErrorSnackbar errorMsg={basicInfoErrorMsg} />}
      {basicInfoSuccessMsg && <SuccessSnackbar successMsg={basicInfoSuccessMsg} />}
    </>
  );
};

export default DMBasicInfo;
